import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AclRoute, WorkerAclKeys, withPermission } from '@/lib/acl';

/**
 * Segment layout for `/workforce` (Workers) — gates the whole subtree (listing +
 * worker detail) behind `workers:listing:read` via a single gated Outlet. (ENT-89 T15.)
 */
export const Route = createFileRoute('/workforce')({
  component: withPermission(Outlet, {
    key: WorkerAclKeys.listingRead,
    route: AclRoute.WORKER,
    resourceLabel: 'Workers',
  }),
});
